import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { useI18n } from 'hooks/useI18n';
import { UIOfferResponsability } from 'interfaces/ui/ui-offer-responsability';
import {
  StyledRequirementsResponsabilities,
  StyledRequirementsResponsabilitiesContainer,
  StyledRequirementsResponsabilitiesItem,
  StyledRequirementsResponsabilitiesTitle
} from './RequirementsResponsabilities.styled';

const RequirementsEvolution = ({
  responsabilities,
  migratedToMarkdown
}: {
  responsabilities: UIOfferResponsability[];
  migratedToMarkdown: boolean;
}) => {
  const { t } = useI18n('job-offer');

  return (
    <StyledRequirementsResponsabilitiesContainer>
      <StyledRequirementsResponsabilities>
        <StyledRequirementsResponsabilitiesTitle editorial>
          {t('requisites.responsibilities')}
        </StyledRequirementsResponsabilitiesTitle>
        <ul>
          {responsabilities.map((r) => (
            <StyledRequirementsResponsabilitiesItem key={r.id}>
              <FontAwesomeIcon icon={faCheckCircle} />
              {migratedToMarkdown ? (
                <MarkdownComponent content={r.item || ''} />
              ) : (
                <div dangerouslySetInnerHTML={{ __html: r.item || '' }}></div>
              )}
            </StyledRequirementsResponsabilitiesItem>
          ))}
        </ul>
      </StyledRequirementsResponsabilities>
    </StyledRequirementsResponsabilitiesContainer>
  );
};

export default RequirementsEvolution;
